/**
 * Generates a Destination card that navigates to the appropriate explore page
 *
 * Copyright (c) 2022 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { Badge } from 'reactstrap'
import CoverImage from '../CoverImage'
import Link from '../Link'
import styles from './DestinationCard.module.scss'

const DestinationCard = ({
  linkProps,
  destination,
  photoUrl,
  labelColor,
  textColor,
  cardClass
}) => {
  const Card = useMemo(() => (
    <CoverImage className={cx(styles['destination-card-content'], cardClass)} photoUrl={photoUrl}>
      <div className='d-flex align-items-end h-100'>
        <Badge
          className={cx(styles['destination-label'])}
          style={{ backgroundColor: labelColor, color: textColor }}>
          {destination}
        </Badge>
      </div>
    </CoverImage>
  ), [destination, labelColor, textColor, photoUrl, cardClass])

  return (
    linkProps ? (
      <Link {...linkProps} className={cx(styles['card-link'], linkProps.className)}>
        {Card}
      </Link>
    ) : Card
  )
}

DestinationCard.defaultProps = {
  labelColor: styles.labelColor,
  textColor: styles.textColor
}

DestinationCard.propTypes = {
  linkProps: PropTypes.object,
  destination: PropTypes.string.isRequired,
  photoUrl: PropTypes.string.isRequired,
  labelColor: PropTypes.string,
  textColor: PropTypes.string,
  cardClass: PropTypes.string
}

export default DestinationCard
